module.exports = __webpack_public_path__ + "static/img/A102.4e49e4f1.jpg";